import React, { useState } from 'react';
import { Link, useNavigate, Outlet } from 'react-router-dom';
import { FaUserPlus, FaPoll, FaSignOutAlt, FaUser } from 'react-icons/fa';
import logo from '../../src/assets/logo.svg';


const AdminMenuBar = () => {
  const navigate = useNavigate();
  const [activeMenuItem, setActiveMenuItem] = useState('');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

const menuItems = [
  //  {
  //   name: 'Dashboard',
  //   icon: <FaPoll className="text-white group-hover:text-[#4BB648] transition-colors duration-300" />,
  //   path: '/dashboard',
  //   key: 'Dashboard'
  // },
  {
    name: 'Candidate Registration',
    icon: <FaUserPlus className="text-white group-hover:text-[#4BB648] transition-colors duration-300" />,
    path: '/candidate-form',
    key: 'AddUserRole'
  },
  {
    name: 'Candidate List',
    icon: <FaPoll className="text-white group-hover:text-[#4BB648] transition-colors duration-300" />,
    path: '/candidate-list',
    key: 'CustomerList'
  },
  {
    name: 'Enquiry Form',
    icon: <FaPoll className="text-white group-hover:text-[#4BB648] transition-colors duration-300" />,
    path: '/enquiry-form',
    key: 'EnquiryForm'
  },
  {
    name: 'Enquiry Form List',
    icon: <FaPoll className="text-white group-hover:text-[#4BB648] transition-colors duration-300" />,
    path: '/enquiry-list',
    key: 'EnquiryFormList'
  },
  // {
  //   name: 'Expenses Form',
  //   icon: <FaPoll className="text-white group-hover:text-[#4BB648] transition-colors duration-300" />,
  //   path: '/income-expenses',
  //   key: 'ExpensesForm'
  // },
  {
    name: 'Master Price List',
    icon: <FaPoll className="text-white group-hover:text-[#4BB648] transition-colors duration-300" />,
    path: '/master-price-list',
    key: 'MasterPriceList'
  },
 
];

  const handleMenuClick = (menuKey) => {
    setActiveMenuItem(menuKey);
    setMobileMenuOpen(false);
  };

  const handleLogout = () => {
    sessionStorage.clear();
    navigate("/", { state: { action: "student" } });
  };

  const navigateToHome = () => {
    navigate('/');
  };

  return (
    <div className="flex h-screen bg-gray-100">
      <header className="fixed top-0 left-0 right-0 z-40 bg-white shadow-md">
        <div className="flex items-center justify-between p-4">
          <button 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="text-gray-800 focus:outline-none lg:hidden"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>

          <div className="flex-grow flex items-center justify-center lg:justify-start">
            <img
              src={logo}
              alt="Logo"
              className="h-12 cursor-pointer"
              onClick={navigateToHome}
            />
          </div>

          <button 
            onClick={() => navigate('/profile')}
            className="ml-2 text-gray-800 hidden lg:block"
          >
            <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center">
              <FaUser className="text-gray-600" />
            </div>
          </button>
        </div>
      </header>

      <aside 
  className={`fixed top-0 left-0 z-30 w-64 h-full bg-custom-green transition-all duration-300 ease-in-out 
    ${mobileMenuOpen ? 'translate-x-0' : '-translate-x-full'} lg:translate-x-0`}
>
        <div className="flex flex-col h-full">
          <div className="p-4 hidden lg:block">
            <img
              src={logo}
              alt="Logo"
              className="h-12 cursor-pointer mx-auto"
              onClick={navigateToHome}
            />
          </div>

<nav className="flex-1 overflow-y-auto mt-[70px] lg:mt-0">
    <ul className="py-4 md:py-4">
    {menuItems.map((item) => (
      <li key={item.key} className="group">
        <Link
          to={item.path}
          onClick={() => handleMenuClick(item.key)}   // 👈 set active when clicked
          className={`flex items-center w-full px-6 py-3 text-left font-bold transition-colors duration-300 
            ${activeMenuItem === item.key 
              ? 'bg-white text-[#4BB648]'    // 👈 active styles
              : 'text-white hover:bg-white hover:text-[#4BB648]'}`}
        >
         <span
  className={`mr-4 transition-colors duration-300 
    ${activeMenuItem === item.key 
      ? 'text-[#4BB648]'   // ✅ active icon green
      : 'text-white group-hover:text-[#4BB648]'}`}
>
  {item.icon}
</span>

<span
  className={`transition-colors duration-300 
    ${activeMenuItem === item.key 
      ? 'text-[#4BB648]'   // ✅ active text green
      : 'text-white group-hover:text-[#4BB648]'}`}
>
  {item.name}
</span>

        </Link>
      </li>
    ))}
  </ul>
 
</nav>

          {/* Bottom Menu */}
         <div className="py-4 border-t-2 border-b-2 border-white flex items-center justify-center">
  <button
    onClick={handleLogout}
    className="flex items-center text-white hover:text-green-200"
  >
    <FaSignOutAlt className="mr-2" />
    <span className="font-bold">Logout</span>
  </button>
</div>

        </div>
      </aside>

      {/* Overlay for mobile menu */}
      {mobileMenuOpen && (
        <div 
          className="fixed inset-0 z-20 bg-black bg-opacity-50 lg:hidden"
          onClick={() => setMobileMenuOpen(false)}
        ></div>
      )}



       <main className="flex-1 overflow-y-auto pt-20 lg:pt-0 lg:ml-64">
        <div className="p-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminMenuBar;